// extracted by mini-css-extract-plugin
export default {"base":"CbsaStat_base__MRa9J"};